import { http } from "config/http";

export const getChartsData = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`dashboard`, destinationObject)
        return res?.data
    } catch (error) {
        return error
    }
}

export const getUserDashboardData = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`user_dashboard`, destinationObject)
        return res?.data
    } catch (error) {
        return error
    }
}